export default {"src":"/_next/static/media/TU.53e48cb6.svg","height":18,"width":18};